export const ROUTES = {
  home: "/",
  forDoctors: "/for-doctors/",
  classificationOfAnomalies: "/classification-of-anomalies/",
};
